export default "__VITE_ASSET__CRapbVjd__"